import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { from, of, Subscription } from 'rxjs';
import { applicationPermissions } from 'src/app/shared/application-constants/application-permissions';
import { UserStorageService } from 'src/app/modules/user/services/user-storage.service';
import { StpTrainer } from 'src/app/modules/stp-registration/models/stp-trainer.model';
import { StpOccupationTool } from 'src/app/modules/stp-registration/models/stp-occupation-tool.model';
import { Furniture } from 'src/app/modules/stp-registration/models/furniture.model';
import { StpManagement } from 'src/app/modules/stp-registration/models/stp-management.model';
import { TempApproveRejectStpUserDto } from 'src/app/modules/stp-registration/DTO/temp-approve-reject-stp-user-dto';
import { CommonStorageService } from 'src/app/shared/services/common-storage.service';
import { StpRegistrationStorageService } from 'src/app/modules/stp-registration/services/stp-registration-storage.service';
import { StpRegistrationService } from 'src/app/modules/stp-registration/services/stp-registration.service';
import { StpRegistrationRenewReapplyService } from '../../services/stp-registration-renew-reapply.service';
import { RequestData } from 'src/app/modules/stp-registration/models/stp_onlinePayment.model';
import { finalize, switchMap } from 'rxjs/operators';
import { StpUserStatusEnum } from 'src/app/shared/enumHelper/stp-user-status';

@Component({
  selector: 'app-stp-archive-application-view-renew-reapply',
  templateUrl: './stp-archive-application-view-renew-reapply.component.html',
  styleUrls: ['./stp-archive-application-view-renew-reapply.component.scss']
})
export class StpArchiveApplicationViewRenewReapplyComponent implements OnInit {
fullStpApplicationDetails: any;

  basicProfileForm!: FormGroup;
  approveRejectForm!: FormGroup;
  physicalInfraForm!: FormGroup;
  paymentForm!: FormGroup;

  pdfBlob: File;

  financialDetailForm!: FormGroup;
  stpTrainers: StpTrainer[] = [];
  stpOccupationTools: StpOccupationTool[] = [];
  furnitures: Furniture[] = [];
  stpManagements: StpManagement[] = [];
  paymentList: any;
  isCommitte: boolean;
  approveDate: Date;
  expiredDate: Date;
  isApplicationSubmitted: boolean = false;
  isSubmitting: boolean = false;
  isApplicationPaidButNotSubmitted: boolean = false;
  isRenewalApplication: boolean = false;

  totalIncomes: number;
  totalExpenses: number;
  requestData: RequestData = new RequestData();
  currentUserInfo: any;
  userInfo: any;
  userId: any;
  userInfoId: any;
  userEmail: any;
  isUser: boolean = false;
  isAdmin: boolean = false;
  isManualPayment = false;
  isOnlinePayment = false;
  paySlip: String;
  isComplete$: Subscription;
  transactionNumber: any;
  tempApproveRejectStpUserDto: TempApproveRejectStpUserDto =
    new TempApproveRejectStpUserDto();
  applicationPermissions = applicationPermissions;
  isTempRejected: any;
  approvalStatus: any;

  tempRejectReason: string;
  isShown: boolean = false;

  stpEmail: string;
  stpContactEmail: string;
  stpExpireDate: Date;
  isStpExpired: boolean = false;

  isVisible = false;

  financingApplicationList: any;

  stpMainId: number;
  stpMainDumpId: number;
  applicationId: string;
  stpMainDumpInfo: any[];
  stpRollbackHistory: any[] = [];
  stpUserStatus: any;

  constructor(
    private fb: FormBuilder,
    public datepipe: DatePipe,
    private fbPhyInfra: FormBuilder,
    private fbFinancial: FormBuilder,
    private stpPayment: FormBuilder,
    private commonStorageService: CommonStorageService,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private stpRegistrationService: StpRegistrationService,
    private notification: NzNotificationService,
    private userStorageService: UserStorageService,
    private route: ActivatedRoute,
    private router: Router,
    // private financialStorageService: FinancialStorageService
    private stpRegistrationRenewReapplyService: StpRegistrationRenewReapplyService,
  ) {
    this.route.queryParams.subscribe((params) => {
      this.stpMainId = +params['stpMainId']; // convert to number
      this.stpMainDumpId = +params['stpMainDumpId']; // convert to number
    });
    this.getStpDumpInfoByStpMainIdAndStpMainDumpId();
  }

  ngOnInit() {
    this.currentUserInfo = localStorage.getItem('currentUserInfo');
    this.userInfo = JSON.parse(this.currentUserInfo) || null;
    if (this.userInfo) {
      this.userId = this.userInfo.id;
    }
    if (
      this.userInfo.roles[0].name.toLowerCase() === 'user' ||
      this.userInfo.roles[0].name.toLowerCase() === 'stp_master'
    ) {
      this.isUser = true;
    }
    if (this.userInfo.roles[0].name.toLowerCase() === 'ict_admin') {
      this.isAdmin = true;
    }

    this.basicProfileForm = this.fb.group({
      //#region Basic Profile
      stpName: [''],
      stpNameBangla: [''],
      stpTypeId: [''],
      // stpOwnerTypeId: ['', Validators.required],
      stpOwnershipTypeId: [''],
      stpMinistryId: [''],
      stpAgencyId: [''],
      establishYear: [''],
      stpLocationId: [''],

      //#endregion Basic Profile

      //#region Address of the organization

      stpCountryId: [''],
      stpPostOfficeId: [''],
      address: [''],
      contactNo: [''],
      email: [''],
      division_id: [''],
      district_id: [''],
      upazilla_id: [''],

      // don't find  (Website address) property from ERD

      //#endregion Address of the organization

      //#region Contact Person

      contactName: [''],
      contactDesignation: [''],
      contactNumber: [''],
      contactEmail: [''],

      //#endregion Contact Person

      //#region  commitee

      isCommittee: [''],
      totalMember: [''],
      totalFemaleMember: [''],
      approvalDateCommittee: [''],
      expirationDateCommittee: [''],
      // don't use my html upload tag
      //#endregion commitee

      //#region application details
      // stpApplicationStatusId: ['', Validators.required],
      // stpAppTypeId: ['', Validators.required],
      // registrationNo: ['', Validators.required],
      // approvalDate: ['', Validators.required],
      applicationDate: [''],
      stpApplicationStatus: [''],

      //#endregion application details
    });
    this.physicalInfraForm = this.fbPhyInfra.group({
      infrastructureName: ['demoName'],
      stpOwnershipStatus: [''],
      stpBuildingType: [''],
      totalArea: [''],
      noOfFloor: [''],
      noOfClassroom: [''],
      sizeOfClassroom: [''],
      noOfWorkshop: [''],
      sizeOfWorkshop: [''],
      noOfClub: [''],
      sizeOfClub: [''],
      noOfOffice: [''],
      noOfTrainerRoom: [''],
      noOfWashroom: [''],
      noOfFemaleWashroom: [''],
      isDisableFriendly: [{ value: '', disabled: true }],
      isElectricity: [{ value: '', disabled: true }],
      isInternet: [{ value: '', disabled: true }],
      isDrinkingWater: [{ value: '', disabled: true }],
      isFireEq: [{ value: '', disabled: true }],
      isLibrary: [{ value: '', disabled: true }],
      isLightingVent: [{ value: '', disabled: true }],
    });
    this.financialDetailForm = this.fbFinancial.group({
      reserveFund: [null],
      fdr: [null],
      generalFund: [''],
      availableBalanceInBankAccount: [''],
      accountNumber: [''],
      bankName: [''],
      branchName: [''],
      otherFunds: [null],
      remarks: [''],
      feesFromStudents: [''],
      incomeFromOwnAssets: [''],
      fromGovernment: [''],
      developmentCharge: [''],
      admissionFee: [''],
      examinationFee: [''],
      sessionCharge: [''],
      sellingOfProductsProduced: [''],
      others_source: [''],
      salaryOfInstructorsAndStaff: [''],
      incidentalExpenses: [''],
      repairingCost: [''],
      examinationExpenses: [''],
      travelExpenses: [''],
      procurementOfBooks: [''],
      procurementOfTrainingLearningMaterials: [''],
      procurementOfRawMaterials: [''],
      others_head: [''],
    });
    this.paymentForm = this.stpPayment.group({
      amount: [''],
      generationDate: [''],
      successDate: [''],
      payDate: [''],
      bankName: [''],
      isSuccess: [''],
      paySlip: [''],
      transactionNo: [''],
    });

    this.approveRejectForm = this.fb.group({
      //#region Basic Profile
      rejectReason: [null],
    });

    this.getStpApplicationById();
    // this.getFinancingApplicationNotificationByStpMainId();

    // let submitApplication = localStorage.getItem('submitApplication');
    // if(submitApplication){
    //   localStorage.removeItem('submitApplication');
    //   this.onSubmitApplication();
    // }
  }

  // getFinancingApplicationNotificationByStpMainId(){
  //   this.financialStorageService.getFinancingApplicationNotificationByStpMainId(this.stpMainId)
  //     .subscribe({
  //       next: (res) => {
  //         if (res.success) {
  //           this.financingApplicationList = res?.data;
  //         }
  //       }
  //     });
  // }

  getUserProfile() {
    this.userStorageService.getUserProfile(this.userInfoId).subscribe({
      next: (response) => {
        this.userEmail = response.data?.email;
      },
      error: (error) => this.notification.error('Failed', error.message),
    });
  }

  private getStpApplicationById() {
    this.stpRegistrationRenewReapplyService
      .getStpMainDumpInfoByStpMainDumpId(this.stpMainDumpId)
      .subscribe(
        (res) => {
          this.isTempRejected = res.data?.stpMain?.isTempRejected;
          this.approvalStatus = res.data?.stpMain?.isApproved;

          this.fullStpApplicationDetails = res;

          this.userInfoId = res.data?.stpMainDump?.createdBy;
          if (this.userInfoId != null) {
            this.getUserProfile();
          }

          if (res.success) {
            if (res.data.stpMain.tempRejectReason) {
              this.tempRejectReason = res.data.stpMain.tempRejectReason;
              this.isShown = true;
            } else {
              this.isShown = false;
            }

            this.stpEmail = res.data?.stpMain?.email;
            this.stpContactEmail = res.data?.stpMain?.contactEmail;
            this.stpExpireDate = res.data?.stpMain?.expireDate;

            if (
              this.stpExpireDate &&
              new Date(this.stpExpireDate) < new Date()
            ) {
              this.isStpExpired = true;
            }

            this.basicProfileForm.patchValue({
              stpName: res.data?.stpMain?.stpName,
              stpNameBangla: res.data?.stpMain?.stpNameBangla,
              stpTypeId: res.data?.stpMain?.stpType?.typeName,
              stpOwnershipTypeId: res.data?.stpMain?.stpOwnershipType?.typeName,
              stpMinistryId: res.data?.stpMain?.stpMinistry?.ministryName,
              stpAgencyId: res.data?.stpMain?.stpAgency?.agencyName,
              establishYear: this.datepipe.transform(
                res.data?.stpMain?.establishYear,
                'yyyy',
              ),
              stpLocationId: res.data?.stpMain?.stpLocation?.locationName,

              stpCountryId: res.data?.stpMain?.sysCountry?.countryName,
              stpPostOfficeId: res.data?.stpMain?.postOffice,
              address: res.data?.stpMain?.address,
              contactNo: res.data?.stpMain?.contactNo,
              email: res.data?.stpMain?.email,
              division_id: res.data?.stpMain?.sysDivision?.divisionName,
              district_id: res.data?.stpMain?.sysDistrict?.districtName,
              upazilla_id: res.data?.stpMain?.sysUpazilla?.upazillaName,

              contactName: res.data?.stpMain?.contactName,
              contactDesignation: res.data?.stpMain?.contactDesignation,
              contactNumber: res.data?.stpMain?.contactNumber,
              contactEmail: res.data?.stpMain?.contactEmail,

              isCommittee: res.data?.stpMain?.isCommittee,
              totalMember: res.data?.stpCommittee?.totalNumber,
              totalFemaleMember: res.data?.stpCommittee?.totalFemaleMember,
              approvalDateCommittee: this.datepipe.transform(
                res.data?.stpCommittee?.approvalDate,
                'dd-MM-yyyy',
              ),
              expirationDateCommittee: this.datepipe.transform(
                res.data?.stpCommittee?.expireDate,
                'dd-MM-yyyy',
              ),
            });
            if (res.data?.stpMain?.isCommittee === true) {
              this.isCommitte = true;
            } else {
              this.isCommitte = false;
            }

            // this.paymentForm.patchValue({
            //   amount: res.data?.stpPayments?.amount,
            //   generationDate: res.data?.stpPayments?.bankName,
            //   successDate: res.data?.stpPayments?.successDate,
            //   payDate: this.datepipe.transform(
            //     res.data?.stpPayments?.payDate,
            //     'dd-MM-YYYY'
            //   ),
            //   bankName: res.data?.stpPayments?.bankName,
            //   isSuccess: res.data?.stpPayments?.isSuccess,
            //   paySlip: res.data?.stpPayments?.paySlip,
            //   transactionNo: res.data?.stpPayments?.transactionNo,
            // });

            // if (res.data?.stpPayments?.stpPaymentType?.id === 2) {
            //   this.isManualPayment = true;
            // }
            // if (res.data?.stpPayments?.stpPaymentType?.id === 1) {
            //   this.isOnlinePayment = true;
            //   this.transactionNumber = res.data?.stpPayments?.transactionNo;
            // }
            // if (res.data?.stpPayments?.paySlip) {
            //   this.paySlip = res.data?.stpPayments?.paySlip;
            // }
            this.physicalInfraForm.patchValue({
              stpOwnershipStatus:
                res.data?.stpInfrastructure?.stpBuildingType?.typeName,
              stpBuildingType:
                res.data?.stpInfrastructure?.stpOwnershipStatus?.typeName,
              totalArea: res.data?.stpInfrastructure?.totalArea,
              noOfFloor: res.data?.stpInfrastructure?.noOfFloor,
              noOfClassroom: res.data?.stpInfrastructure?.noOfClassroom,
              sizeOfClassroom: res.data?.stpInfrastructure?.sizeOfClassroom,
              noOfWorkshop: res.data?.stpInfrastructure?.noOfWorkshop,
              sizeOfWorkshop: res.data?.stpInfrastructure?.sizeOfWorkshop,
              noOfClub: res.data?.stpInfrastructure?.noOfClub,
              sizeOfClub: res.data?.stpInfrastructure?.sizeOfClub,
              noOfOffice: res.data?.stpInfrastructure?.noOfOffice,
              noOfTrainerRoom: res.data?.stpInfrastructure?.noOfTrainerRoom,
              noOfWashroom: res.data?.stpInfrastructure?.noOfWashroom,
              noOfFemaleWashroom:
                res.data?.stpInfrastructure?.noOfFemaleWashroom,
              isDisableFriendly: res.data?.stpInfrastructure?.isDisableFriendly,
              isElectricity: res.data?.stpInfrastructure?.isElectricity,
              isInternet: res.data?.stpInfrastructure?.isInternet,
              isDrinkingWater: res.data?.stpInfrastructure?.isDrinkingWater,
              isFireEq: res.data?.stpInfrastructure?.isFireEq,
              isLibrary: res.data?.stpInfrastructure?.isLibrary,
              isLightingVent: res.data?.stpInfrastructure?.isLightingVent,
            });

            this.financialDetailForm.patchValue({
              reserveFund: res.data?.stpFund?.reserveFund
                ? parseFloat(res.data?.stpFund?.reserveFund)
                : 'NA',
              fdr: parseFloat(res.data?.stpFund?.fdr),
              generalFund: res.data?.stpFund?.generalFund
                ? parseFloat(res.data?.stpFund?.generalFund)
                : 'NA',
              availableBalanceInBankAccount: parseFloat(
                res.data?.stpFund?.availableBalance,
              ),
              accountNumber: res.data?.stpFund?.accountNo,
              bankName: res.data?.stpFund?.bankName,
              branchName: res.data?.stpFund?.branchName,
              otherFunds: parseFloat(res.data?.stpFund?.otherFund),
              remarks: res.data?.stpFund?.remarks,

              feesFromStudents: parseFloat(
                res.data?.stpIncome?.feesFromStudent,
              ),

              incomeFromOwnAssets: parseFloat(
                res.data?.stpIncome?.ownAssetIncome,
              ),
              fromGovernment: parseFloat(res.data?.stpIncome?.govIncome),
              developmentCharge: parseFloat(
                res.data?.stpIncome?.developmentCharge,
              ),
              admissionFee: parseFloat(res.data?.stpIncome?.admissionFee),
              examinationFee: parseFloat(res.data?.stpIncome?.examFee),
              sessionCharge: parseFloat(res.data?.stpIncome?.sessionCharge),
              sellingOfProductsProduced: parseFloat(
                res.data?.stpIncome?.prodSell,
              ),
              others_source: parseFloat(res.data?.stpIncome?.other),
              salaryOfInstructorsAndStaff: parseFloat(
                res.data?.stpExpense?.salary,
              ),
              incidentalExpenses: parseFloat(res.data?.stpExpense?.incidental),
              repairingCost: parseFloat(res.data?.stpExpense?.repairing),
              examinationExpenses: parseFloat(res.data?.stpExpense?.exam),
              travelExpenses: parseFloat(res.data?.stpExpense?.travel),
              procurementOfBooks: parseFloat(res.data?.stpExpense?.procBooks),
              procurementOfTrainingLearningMaterials: parseFloat(
                res.data?.stpExpense?.procTraining,
              ),
              procurementOfRawMaterials: parseFloat(
                res.data?.stpExpense?.procRawMat,
              ),
              others_head: parseFloat(res.data?.stpExpense?.others),
            });

            this.totalIncomes =
              parseFloat(res.data.stpIncome.feesFromStudent || 0) +
              parseFloat(res.data.stpIncome.ownAssetIncome || 0) +
              parseFloat(res.data.stpIncome.govIncome || 0) +
              parseFloat(res.data.stpIncome.developmentCharge || 0) +
              parseFloat(res.data.stpIncome.admissionFee || 0) +
              parseFloat(res.data.stpIncome.examFee || 0) +
              parseFloat(res.data.stpIncome.sessionCharge || 0) +
              parseFloat(res.data.stpIncome.prodSell || 0) +
              parseFloat(res.data.stpIncome.other || 0);

            this.totalExpenses =
              parseFloat(res.data.stpExpense.salary || 0) +
              parseFloat(res.data.stpExpense.incidental || 0) +
              parseFloat(res.data.stpExpense.repairing || 0) +
              parseFloat(res.data.stpExpense.exam || 0) +
              parseFloat(res.data.stpExpense.travel || 0) +
              parseFloat(res.data.stpExpense.procBooks || 0) +
              parseFloat(res.data.stpExpense.procTraining || 0) +
              parseFloat(res.data.stpExpense.procRawMat || 0) +
              parseFloat(res.data.stpExpense.others || 0);

            this.stpTrainers = res.data?.stpTrainerList;
            this.stpOccupationTools = res.data?.stpToolsList;
            this.furnitures = res.data?.stpFurnitureList;
            this.stpManagements = res.data?.stpStaffList;

            this.isRenewalApplication = res?.data?.stpMainDump?.isRenewed;            

            if (
              res?.data?.stpMainDump?.stpUserStatus?.id == 3 &&
              res?.data?.stpMainDump?.isPayment == true
            ) {
              this.isApplicationSubmitted = true;
            }

            if (
              res?.data?.stpMainDump?.stpUserStatus?.id == 2 &&
              res?.data?.stpMainDump?.isPayment == true
            ) {
              this.isApplicationPaidButNotSubmitted = true;
            }
            // this.stpRegistrationService.setCheckIsCompleteRegistration(this.isApplicationSubmitted);

            // this.isComplete$ = this.stpRegistrationService
            //   .getCheckIsCompleteRegistration()
            //   .subscribe((res) => {
            //     this.isApplicationSubmitted = res;
            //   });

            this.getPaymentListByStpMainId();
          } else {
            this.notification.error('Failed', 'STP Application Not Found!');
          }
        },
        (error) => {
          this.notification.error('Failed', 'STP Application Not Found!');
        },
      );
  }

  getPaymentListByStpMainId() {
    this.stpRegistrationRenewReapplyService
      .getPaymentListByStpMainId(this.stpMainId)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.paymentList = res?.data;
          }
        },
      });
  }

  constructRequestData() {
    this.userInfo = JSON.parse(localStorage.getItem('currentUserInfo') || '{}');
  }

  onSubmitPaymentRequest() {
    this.constructRequestData();
    const PAYMENT_PROFILE = {
      RENEWAL: 2,
      REAPPLY: 3,
    };
    const payload = {
      userId: this.userInfo.id,
      paymentProfileId: this.isRenewalApplication === true
        ? PAYMENT_PROFILE.RENEWAL
        : PAYMENT_PROFILE.REAPPLY,
    };
    this.stpRegistrationStorageService
      .initiateRenewReapplyPaymentRequest(payload)
      .subscribe((response) => {
        localStorage.setItem(
          'windowLocation',
          '/home/stp-registration/stp-application-view-renew-reapply?stpMainId=' +
            this.stpMainId +
            '&stpMainDumpId=' +
            this.stpMainDumpId,
        );
        // localStorage.setItem('submitApplication', 'submit');
        window.location.href = response.data;
      });
  }

  onSubmitApplication() {
    this.isSubmitting = true;

    this.stpRegistrationRenewReapplyService
      .submitStpMainDumpInfoByStpMainDumpId(this.stpMainDumpId)
      .pipe(
        switchMap((response) => {
          if (!response.success) {
            throw new Error('Submission failed');
          }

          const isCompleted =
            response.data?.stpUserStatus?.id === StpUserStatusEnum.Completed;
          const isPaid = response.data?.isPayment === true;

          if (isCompleted && isPaid) {
            this.isApplicationSubmitted = true;
            this.isApplicationPaidButNotSubmitted = false;

            return from(this.onSuccessSubmitFinalMail());
          }

          return of(null);
        }),
        finalize(() => {
          this.isSubmitting = false;
        }),
      )
      .subscribe({
        next: () => {
          this.router.navigate(
            ['/home/stp-registration/stp-application-view-renew-reapply'],
            {
              queryParams: {
                stpMainId: this.stpMainId,
                stpMainDumpId: this.stpMainDumpId,
              },
            },
          );
        },
        error: (error) => {
          this.notification.error(
            'Failed',
            error?.message || 'Submission failed',
          );
        },
      });
  }

  async onSuccessSubmitFinalMail() {
    let mailingFormData = new FormData();
    mailingFormData.append(
      'subject',
      'Congratulation on Submitting your application',
    );
    mailingFormData.append(
      'message',
      'We, the authority of NSDA are very much delightful to have you here. Thank you for submitting your application',
    );
    mailingFormData.append('email', this.userInfo.email);
    mailingFormData.append('stpEmail', this.stpEmail);
    mailingFormData.append('stpContactEmail', this.stpContactEmail);
    await this.openPDF();
    mailingFormData.append('file', this.pdfBlob);

    this.stpRegistrationStorageService
      .mailingBasicProfile(mailingFormData)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.notification.success(
              'Success!',
              'Application successfully mailed. Please check your mail.',
            );

            this.router.navigate(
              ['/home/stp-registration/stp-application-view-renew-reapply'],
              {
                queryParams: {
                  stpMainId: this.stpMainId,
                  stpMainDumpId: this.stpMainDumpId,
                },
              },
            );
          } else {
            this.notification.error('Failed', 'Email could not be send.');
          }
        },
      });
  }

  async openPDF() {
    let data = document.getElementById('basicProfileDetails')!;
    // let pdf = new jsPDF('p', 'mm', 'a4');
    // Reduced size of pdf
    let pdf = new jsPDF('p', 'mm', 'a4', true);
    let stpName = this.fullStpApplicationDetails.data?.stpMain?.stpName
      ? this.fullStpApplicationDetails.data?.stpMain?.stpName
      : 'report';
    let pdfName = stpName + '.pdf';
    await html2canvas(data).then(async (canvas) => {
      // Few necessary setting options
      var imgWidth = 208;
      var pageHeight = 295;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      let pageNumber = 1;
      if (imgHeight % pageHeight != 0) {
        pageNumber = imgHeight / pageHeight + 1;
        pageNumber = Math.floor(pageNumber);
      } else {
        pageNumber = imgHeight / pageHeight;
      }

      let contentDataURL = canvas.toDataURL('image/png');
      var position = 0;
      while (pageNumber >= 0) {
        position = heightLeft - imgHeight;
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        pageNumber--;

        if (pageNumber == 0) {
          break;
        }
        pdf.addPage();
      }
      // Generated PDF and downlonding PDF
      let blob = pdf.output('blob');
      this.pdfBlob = new File([blob], pdfName, { type: 'application/pdf' });
    });
  }

  onDownload(paySlip: any): void {
    // @ts-ignore
    this.commonStorageService.downloadFile(paySlip).subscribe(
      (data: any) => {
        var fileName = 'report.pdf';
        const contentDisposition = data.headers.get('Content-Disposition');
        if (contentDisposition) {
          const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = fileNameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
          }
        }
        saveAs(data.body, fileName);
      },
      (err) => {},
    );
  }

  async onStpDownload() {
    await this.openPDF();
    saveAs(this.pdfBlob, this.pdfBlob.name);
  }

  setRejectApplication(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  onRejectApplication(): void {
    if (!this.approveRejectForm.value.rejectReason) {
      this.notification.warning(
        'Warning',
        'Please! fill up reject Reason field',
      );
      return;
    }
    this.tempApproveRejectStpUserDto.tempRejectReason =
      this.approveRejectForm.value.rejectReason;
    this.tempApproveRejectStpUserDto.isTempRejected = true;
    this.tempApproveRejectStpUserDto.stpMainId = this.stpMainId;

    // Payment Related Issue option was removed from the modal
    this.tempApproveRejectStpUserDto.isPaymentIssue = false;

    this.stpRegistrationStorageService
      .reviewRenewReapplyApplication(this.tempApproveRejectStpUserDto)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.isVisible = false;
            this.notification.success(
              'Success!',
              'Correction requested successfully ',
            );
            this.router.navigate(['home/stp-registration/stp-applications']);
          } else {
            this.notification.warning('Warning!', res.message);
          }
        },
        error: (error) => {
          this.notification.error('Failed', 'Please! Try again');
        },
      });
  }

  onApproveApplication(): void {
    this.tempApproveRejectStpUserDto.isTempRejected = false;
    this.tempApproveRejectStpUserDto.stpMainId = this.stpMainId;
    this.stpRegistrationStorageService
      .reviewRenewReapplyApplication(this.tempApproveRejectStpUserDto)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.notification.success(
              'Success!',
              'Application accepted successfully',
            );
            this.router.navigate(['home/stp-registration/stp-applications']);
          }
        },
        error: (error) => {
          this.notification.error('Failed', 'Please! Try again');
        },
      });
  }


  getStpDumpInfoByStpMainIdAndStpMainDumpId() {
    if (!this.stpMainId || !this.stpMainDumpId) {
      return;
    }

    this.stpRegistrationRenewReapplyService
      .readStpDumpInfo(this.stpMainId, this.stpMainDumpId)
      .subscribe({
        next: (res) => {
          if (res?.success) {
            this.stpMainDumpInfo = res.data;
            this.applicationId = res.data?.applicationId;
            this.stpUserStatus = res.data?.stpUserStatus?.id;

            if (this.stpUserStatus === 2) {
              this.getStpRollbackHistory();
            }
          }
        },
        error: (res) => {
          console.error('Error fetching history:', res);
        },
      });
  }

  getStpRollbackHistory() {
    this.stpRegistrationRenewReapplyService
      .readStpRollbackHistory(this.stpMainDumpId)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.stpRollbackHistory = (res.data || []).filter(
              (item: any) => item.rollbackApplicationTypeId === 1,
            );
          } else {
            this.stpRollbackHistory = [];
          }
        },
      });
  }
}
